const tooltipsTriggers = document.querySelectorAll('[data-tooltip]');

tooltipsTriggers.forEach(tooltipTrigger => {
  tooltipTrigger.addEventListener('mouseenter', () => openTooltip(tooltipTrigger));
  tooltipTrigger.addEventListener('mouseleave', () => closeTooltip(tooltipTrigger));
});

function openTooltip(tooltipTrigger) {
  const tooltipContent = tooltipTrigger.dataset.tooltipText;

  if (!tooltipContent) {
    return;
  }

  const tooltip = generateTooltip(tooltipContent);

  tooltipTrigger.appendChild(tooltip);

  tooltipTrigger.classList.add('is-open-tooltip');
}

function closeTooltip(tooltipTrigger) {
  const tooltipElement = tooltipTrigger.querySelector('[data-tooltip-element]');

  if (!tooltipElement) {
    return;
  }

  tooltipElement.remove();

  tooltipTrigger.classList.remove('is-open-tooltip');
}

function generateTooltip(content) {
  const tooltip = document.createElement('span');

  tooltip.setAttribute('data-tooltip-element', '');
  tooltip.textContent = content;
  
  return tooltip;
}